import { ExtendedFile } from '@/types';
import { Button, Input, Space } from 'antd';
import { FC, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

type Props = {
  onSubmit: (value) => void;
};

const InputUrl: FC<Props> = (props: Props) => {
  const { onSubmit } = props;
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const onChange = ({ target: { value: targetValue } }) => {
    setValue(targetValue);
  };

  const handleSubmitUrl = async (url) => {
    setLoading(true);
    try {
      const filename = url.substring(url.lastIndexOf('/') + 1);
      const uniqueNumber = uuidv4();
      const file = await fetch(`${url}?v=${uniqueNumber}`)
        .then((r) => r.blob())
        .then((blobFile) => {
          return new File([blobFile], `${uniqueNumber}_${filename}`);
        });
      const files = [file].map((f: ExtendedFile) =>
        Object.assign(f, {
          preview: URL.createObjectURL(f),
        })
      );
      onSubmit(files);
    } catch (err) {
      console.error(`Fail to load url: ${url}`, err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space.Compact style={{ paddingBottom: 10 }}>
      <Input placeholder="Url" value={value} onChange={onChange} disabled={loading} />
      <Button type="primary" onClick={() => handleSubmitUrl(value)} loading={loading}>
        Add
      </Button>
    </Space.Compact>
  );
};

export default InputUrl;
